import styled from 'styled-components'

import {
  ListItem,
  listItemHoverStyle,
  ListItemIcon,
  ListItemText,
} from '../List'

export const MentionWrapper = styled.div`
  list-style: none;
  padding: 0px 8px;

  ${ListItemIcon} {
    line-height: 1;
    opacity: 1;
  }

  ${ListItemText} {
    overflow: hidden;
  }

  /* Style selected option (keyboard navigation) */
  & [aria-selected='true'] ${ListItem} {
    ${listItemHoverStyle};
  }
`

export const Wrapper = styled.div`
  position: relative;
  margin: 8px 8px 12px;
`

export const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 1.25rem; /* Single line */
  max-height: calc(1.25rem * 6); /* 6 lines before scroll appears */
  overflow-y: auto;
  resize: none;

  font-size: ${({ theme }) => theme.fontSizes.D};
  line-height: 1.25rem;

  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  background: transparent;

  color: ${({ theme }) => theme.colors.foreground.secondary.B};

  ::placeholder {
    color: ${({ theme }) => theme.colors.foreground.secondary.D};
  }
`
